import { exerciseContentAreEquals, MainExercise } from "@domain/exercise/exercise";

export interface Session {
	exercises: MainExercise[];
}

export function sessionContentAreEquals(session1: Session, session2: Session): boolean {
	if (session1.exercises.length !== session2.exercises.length) {
		return false;
	}
	return session1.exercises.every((exercise, i) => {
		const { ex1, ex2 } = { ex1: exercise, ex2: session2.exercises[i] };
		return exerciseContentAreEquals(ex1, ex2);
	});
}

export function sessionDeepCopy(session: Session): Session {
	return {
		exercises: Array.from(session.exercises, exercise => ({ ...exercise })),
	};
}
